import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.148 18.271"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { fill: "#8d8a84" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17.807 6.046A9.165 9.165 0 0 0 7.007.262a9.155 9.155 0 0 0-6.926 10.1 9.037 9.037 0 0 0 17.963-.22c.05-1.24-.362-1.2-.437-.045a8.425 8.425 0 0 1-2.789 5.311 8.231 8.231 0 0 1-10.995-.049A8.038 8.038 0 0 1 2.657 4.731a7.835 7.835 0 0 1 13.749 1.825c.318.846.491 1.508.677 1.96.161.454.36.7.546.7s.36-.249.472-.788a4.729 4.729 0 0 0-.294-2.382Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8.425 6.095a68.959 68.959 0 0 0 .015 3.117v.038a.689.689 0 0 0 .252.513 135.039 135.039 0 0 0 4.3 3.323c.162.121.429-.19.285-.333-1.28-1.282-2.478-2.668-3.739-3.982l.2.441a31.2 31.2 0 0 0 .17-3.117c.008-.685-1.47-.685-1.483 0Z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }